import { useTranslation as e } from "../../i18n.mjs";
import { isImageSelected as t } from "../image-extension/utils/is-image-selected.mjs";
import { toolbarActionItem as n } from "../../components/content-controls/toolbar-action-item.mjs";
import { getShortcut as r, rawShortcuts as i } from "../../utils/get-shortcuts.mjs";
import { getTextFormatIcon as a, setTextFormat as o } from "./utils/text-format.mjs";
import { useEditorState as s } from "@tiptap/react";
import { useMemo as c } from "react";
import { jsx as l } from "react/jsx-runtime";
//#region src/extensions/text-format-extension/use-text-format-extension-toolbar.tsx
var u = (u, d, f) => {
	let { t: p } = e(), m = s({
		editor: u,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			isActive: e?.isActive(d) ?? !1,
			isImageSelected: t(e)
		})
	}), h = !m?.isEditable || !!m?.isImageSelected, g = m?.isActive;
	return c(() => {
		let e = p(`${d}`), t = r(i[d].toggle), s = a({ formatType: d });
		return n({
			active: g,
			disabled: h,
			icon: /* @__PURE__ */ l(s, {}),
			label: e,
			onClick: () => o({
				formatType: d,
				editor: u
			}),
			tooltip: f ? null : `${e} (${t})`
		});
	}, [
		u,
		d,
		g,
		h,
		f,
		p
	]);
};
//#endregion
export { u as useTextFormatExtensionToolbar };
